var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.95 25.57",
    width: "1.2em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .schedule__cls-1 {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_132",
    "data-name": "Groupe 132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_131",
    "data-name": "Groupe 131"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    className: "schedule__cls-1",
    x: 1,
    y: 3.62,
    width: 20.95,
    height: 20.95,
    rx: 3.66,
    ry: 3.66
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_28",
    "data-name": "Ligne 28",
    className: "schedule__cls-1",
    x1: 16.71,
    y1: 1,
    x2: 16.71,
    y2: 6.24
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_29",
    "data-name": "Ligne 29",
    className: "schedule__cls-1",
    x1: 6.24,
    y1: 1,
    x2: 6.24,
    y2: 6.24
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_30",
    "data-name": "Ligne 30",
    className: "schedule__cls-1",
    x1: 1,
    y1: 11.47,
    x2: 21.95,
    y2: 11.47
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    className: "schedule__cls-1",
    x: 13.78,
    y: 15.93,
    width: 4.49,
    height: 4.49
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.381d81e99fa0d017a300a9cc6df7fd6c.svg";
export { ForwardRef as ReactComponent };